
namespace RioERP.Reports {
    export class InvoiceDetailedReportColumns {
        static columnsKey = 'Reports.InvoiceDetailedReport';
    }
}